import { notificationActionCreators } from '@storeOld/reducers/notification'

// Toasts of the library flows: actions of the legacy notification reducer that
// belong to this module, store_old takes nothing new.
export const LibraryNotifications = {
  removed: notificationActionCreators.setCustomNotification({
    type: 'topaz',
    text: 'Symbol removed from the library',
    toastContainerId: 'secondary',
  }),
  purged: (count: number) => {
    const subject = count === 1 ? 'A symbol was' : `${count} symbols were`

    return notificationActionCreators.setCustomNotification({
      type: 'topaz',
      text: `${subject} removed from the library and deleted from this project`,
      toastContainerId: 'secondary',
    })
  },
  conflict: notificationActionCreators.setCustomNotification({
    type: 'coral',
    text: 'The symbol was changed by someone else, showing the latest version',
    toastContainerId: 'secondary',
  }),
  failed: (text: string) =>
    notificationActionCreators.setCustomNotification({
      type: 'coral',
      text,
      toastContainerId: 'secondary',
    }),
}
